import { toastr } from "react-redux-toastr";
import { client_v2 } from "utils/api";
import queryString from "query-string";

export const getDashboard = (query) => (dispatch, getState) =>
  new Promise(async (resolve, reject) => {
    try {
      const { dashboard } = getState();
      dispatch({
        type: `DASHBOARD_${
          dashboard.status === "success" ? "UPDATING" : "LOADING"
        }`,
      });
      const data = await client_v2.get(
        `/stats/dashboard?${queryString.stringify(query, {
          skipNull: true,
        })}`
      );
      const { data: oms_order_statuses } = await client_v2.get(
        "/stats/dashboard_oms_orders_statuses"
      );

      dispatch({
        type: "DASHBOARD_SUCCESS",
        data: { ...data, oms_order_statuses },
      });

      resolve();
    } catch (err) {
      console.log(err);
      dispatch({ type: "DASHBOARD_FAILURE" });
      toastr.error("Błąd", "Wystąpił błąd podczas pobierania danych");
      reject();
    }
  });
